<template>
  <span id="apptbutton">
    <b-button
      squared
      :block="block"
      :variant="col"
      class="mt-3 shadow"
      @click="route"
    >
      {{ $t("common.make-appointment") }}
      <b-icon
        icon="chevron-right"
        font-scale="0.95"
        aria-hidden="true"
      ></b-icon>
    </b-button>
  </span>
</template>

<script>
export default {
  name: "apptbutton",
  props: ["color", "block"],
  data() {
    return {
      var1: "dark",
      var2: "light",
      bck: "background-color: black;",
    };
  },
  methods: {
    route() {
      this.$router.push("/appointment");
      this.$emit("close");
    },
  },
  computed: {
    col: function () {
      if (this.color === "d") {
        return this.var1;
      } else {
        return this.var2;
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/buttons/ApptButton.vue